import { v4 as uuidv4 } from "uuid";
import { Journal, ModificationAction, ModificationModel, Modification } from "../../../models";
import { DataStoreTable } from "./DataStoreTable";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { awsToSimpleObject } from "../../../main";
import { PlaceTable } from "./PlaceTable";
import omit from "lodash-es/omit.js";

export type IModification = {
    action: ModificationAction | keyof typeof ModificationAction;
    model: ModificationModel | keyof typeof ModificationModel;
    modelId: string;
    modelName: string;
    detail: string;
    collections?: string | null;
};

export type IJournal = {
    id: string;
    contributor?: string | null;
    addedAt: string;
    modification: IModification;
    userAccess?: string[] | null;
    groupAccess?: string[] | null;
    owner?: string | null;
    caveCollection?: string | null;
    scubaCollection?: string | null;

    //TODO: remove
    modifications: IModification[];
};

export function makeEmptyJournal(id: string = uuidv4()): IJournal {
    return {
        id,
    } as IJournal;
}

export class JournalTable extends DataStoreTable<IJournal> {
    constructor(args: DataProviderArgs) {
        super(
            args,
            "journal",
            Journal,
            (obj: any) => awsToSimpleObject(obj),
            (obj: IJournal) =>
                new Journal(
                    omit(obj, [
                        "createdAt",
                        "updatedAt",
                        "_deleted",
                        "_version",
                        "_lastChangedAt",
                    ]) as IJournal
                )
        );
    }

    public async add(
        modification: IModification,
        groupAccess: string[],
        userAccess: string[],
        contributor: string | undefined,
        caveCollection: string | null | undefined,
        scubaCollection: string | null | undefined
    ) {
        return await super.create(
            new Journal({
                addedAt: new Date().toISOString(),
                contributor,
                groupAccess,
                userAccess,
                modification,
                caveCollection,
                scubaCollection,

                //TODO: remove
                modifications: [],
            })
        );
    }

    public async fixupJournalCollections() {
        this._log.info("Fixing up journal collections");
        const journals = Array.from(await this.all());
        const placeTable = this._store.getSource<PlaceTable>("places");
        let count = 0;
        for (const journal of journals) {
            if (!journal.caveCollection || !journal.scubaCollection || !journal.modification) {
                const place = await placeTable.read(journal.modification.modelId);
                if (!journal.caveCollection || !journal.scubaCollection) {
                    if (place) {
                        journal.caveCollection = place.caveCollection;
                        journal.scubaCollection = place.scubaCollection;
                    }
                }

                await this.update(journal);
            }
            ++count;
            if (count % 100 === 0) {
                this._log.info(`Updated ${count} of ${journals.length} journals`);
            }
        }

        this._log.info("Finished fixing up journal collections");
    }
}
